module.exports = "/images/icon.svg?9cd6104b43a817f59a60879acf4ffa7f";